import { Partner, ProductPartner } from '../types';

const partnerDefaults: Readonly<Partner> = {
  name: '',
  links: [],
  shortcode: '',
  metaTagDescription: '',
  logo: '',
  id: 0,
};

export const partnerBuilder = (partner?: Partial<Partner>): Readonly<Partner> => ({
  ...partnerDefaults,
  ...partner,
});

const productPartnerDefaults: Readonly<ProductPartner> = {
  name: '',
  links: [],
  shortcode: '',
};

export const productPartnerBuilder = (
  partner?: Partial<ProductPartner>,
): Readonly<ProductPartner> => ({
  ...productPartnerDefaults,
  ...partner,
});
